const translations = {
    connectionError: 'Connection Error'
};

export default translations;
